import { Card } from '@procurify/ui'

import { Page } from '@webapp/core/components/Page'
import { useProcurifyIntl } from '@webapp/hooks'
import { type Enum } from '@webapp/infrastructure/types/Enum'
import messages from './messages'

export const ExpenseRecordsPageTabs = {
  UNRECORDED: 'unrecorded',
  RECORDED: 'recorded',
} as const
export type ExpenseRecordsPageTabEnum = Enum<typeof ExpenseRecordsPageTabs>

export interface ExpenseRecordsPageParams {
  type: ExpenseRecordsPageTabEnum
}

export const ExpenseRecordsPage = () => {
  const intl = useProcurifyIntl()

  return (
    <Page
      pageTitle={intl.formatMessage(messages.expenseRecordsPageTitle)}
      breadcrumbs={[
        {
          name: intl.formatMessage(messages.expenseRecordsPageTitle),
        },
      ]}
    >
      <Card>
        <Card.Content>
          {intl.formatMessage(messages.moduleLoading)}
        </Card.Content>
      </Card>
    </Page>
  )
}
